import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const OnboardingHybridRegisterDirective = angularDirectiveToReact('onboardingHybridRegister', {});

export function OnboardingHybridRegisterComponent() {
    const [key] = useAngularToReactRoute();
    return <OnboardingHybridRegisterDirective key={key} />;
}
